import { Box, Chip, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core/";
import Grid from "@material-ui/core/Grid";

import { useDefaultColumn } from "../../../../util/filter";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { useMyWorkorders } from "../../projectQueries";
import { CalibrationTable } from "./calibrationTable";
import { formatDateDate } from "../../../common/formatDate";
import { Edit } from "@material-ui/icons";
import { CalibrationEdit } from "./calibrationEdit";
import { useCalibration } from "../../../intake/intakeQueries";

export const CalibrationPage = ({ id }: any) => {
  const defaultColumn = useDefaultColumn();
  const {
    error: error,
    data: data,
    isLoading: isLoading,
    isError: isError,
  } = useCalibration(id);


  if (isLoading) {
    return (<LinearProgress></LinearProgress>)
  }

  if (isError) {
    return (<ErrorMessage error={error}></ErrorMessage>)
  }

  function getBG(): import("csstype").Property.BackgroundColor | undefined {
    if (data.days_to_next_calibration <= 0) {
      return "red";
    } else if (data.days_to_next_calibration <= 30) {
      return "orange";
    } else {
      return "green";
    }
  }
  function getColor(): import("csstype").Property.Color | undefined {
    if (data.days_to_next_calibration <= 0) {
      return "white";
    } else if (data.days_to_next_calibration <= 30) {
      return "white";
    } else {
      return "black";
    }
  }
  //     error,
  //     isLoading,
  //     isError,
  //     isSuccess,
  //   } = useMyWorkorders(projectID);

  //   if (isLoading) {
  //     return (
  //       <Grid
  //         container
  //         direction="row"
  //         justify="space-between"
  //         alignItems="center"
  //         spacing={4}
  //       >
  //         <Grid item xs={12}>
  //           <LinearProgress />
  //         </Grid>
  //       </Grid>
  //     );
  //   }

  //   if (isError) {
  //     return <ErrorMessage error={error} />;
  //   }


  //   {
  //     id: "Day due in Calibration",
  //     accessor: "days_to_next_calibration",
  //     Cell: ({ cell }: any) => {

  //       var bg = "";
  //       var ft = "";

  //       if (cell.value <= 0) {
  //         bg = "red"
  //         ft = "white"
  //       } else if (cell.value <= 30) {
  //         bg = "orange"
  //         ft = "white"
  //       } else {
  //         bg = "green"
  //         ft = "white"
  //       }





  return (
    <>

      <TableContainer >
        <Table>
          <TableHead style={{ backgroundColor: 'skyblue' }}>
            <TableRow>
              <TableCell align="center" color="green">Last Calibrated Date</TableCell>
              <TableCell align="center">Schedule For The Calibration</TableCell>
              <TableCell align="center">Days Since Calibrated</TableCell>
              <TableCell align="center">Next Calibrated Date</TableCell>
              <TableCell align="center">Days To Next Calibration</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell align="center">{formatDateDate(data.last_calibrated_date)}
                <CalibrationEdit data={data} />
              </TableCell>
              <TableCell align="center">{data.schedule_for_calibration}</TableCell>
              <TableCell align="center">{data.days_since_calibrated}</TableCell>
              <TableCell align="center">{formatDateDate(data.next_calibration_date)}</TableCell>
              <TableCell align="center"><Chip size="medium" label={data.days_to_next_calibration ? data.days_to_next_calibration : 'N/A'} style={{ backgroundColor: getBG(), color: getColor(), }} /></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

    </>
  );
};
